import { ReactElement } from "react";
import styles from "./SensorInfoItem.module.scss";

interface SensorInfoItemProps
{
    label: string,
    value: string | undefined,
    uom: string | undefined
}

const SensorInfoItem = (props: SensorInfoItemProps): ReactElement => (
    <div className={styles.dataItem}>
        <div className={styles.dataLabel}>{props.label}</div>
        <div className={styles.dataValue}>
            {props.value}
            {props.uom}
        </div>
    </div>
);

export default SensorInfoItem;